import { render, staticRenderFns } from "./PremiumRequired.vue?vue&type=template&id=825ccf3c&scoped=true"
import script from "./PremiumRequired.vue?vue&type=script&lang=js"
export * from "./PremiumRequired.vue?vue&type=script&lang=js"
import style0 from "./PremiumRequired.vue?vue&type=style&index=0&id=825ccf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825ccf3c",
  null
  
)

export default component.exports